import { Controller } from "@hotwired/stimulus"

// Cableado wallet A: Status Screen Brick (statusScreen) — vista NATIVA de MercadoPago
// que renderiza el estado real del pago (approved / pending / rejected / 3DS challenge)
// a partir del payment_id. Lo monta TODA la página de result: approved lo enmarca con
// el título y el acuse de créditos propios; el resto solo muestra el brick.
// Si vienen external_resource_url + creq (3DS), los pasa como additionalInfo para
// montar el challenge del banco.
export default class extends Controller {
  static values = {
    publicKey: String,
    paymentId: String,
    externalResourceUrl: String,
    creq: String
  }

  async connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    if (typeof window.MercadoPago === "undefined" || !this.publicKeyValue || !this.paymentIdValue || !this.element.id) {
      console.error("[credit-pack-status] Falta SDK, public key, payment_id o id del container")
      return
    }

    this.brickController = null
    this.unmount = this.unmount.bind(this)
    this.element.innerHTML = ""

    const initialization = { paymentId: this.paymentIdValue }
    // additionalInfo solo para el 3DS challenge.
    if (this.externalResourceUrlValue && this.creqValue) {
      initialization.additionalInfo = {
        externalResourceURL: this.externalResourceUrlValue,
        creq: this.creqValue
      }
    }

    const settings = {
      initialization,
      customization: { visual: { showExternalReference: true } },
      callbacks: {
        onReady: () => {},
        onError: (error) => console.error("[credit-pack-status] Error en Status Screen:", error)
      }
    }

    try {
      const mp = new window.MercadoPago(this.publicKeyValue, { locale: "es-CL" })
      this.createPromise = mp.bricks().create("statusScreen", this.element.id, settings)
        .then((controller) => { this.brickController = controller })
      await this.createPromise
    } catch (error) {
      console.error("[credit-pack-status] Falló el Status Screen Brick:", error)
    }

    document.addEventListener("turbo:before-visit", this.unmount)
    window.addEventListener("beforeunload", this.unmount)
  }

  async disconnect() {
    if (this.createPromise) {
      try { await this.createPromise } catch (_) {}
      this.createPromise = null
    }
    this.unmount()
    document.removeEventListener("turbo:before-visit", this.unmount)
    window.removeEventListener("beforeunload", this.unmount)
  }

  unmount() {
    if (this.brickController) {
      try { this.brickController.unmount() } catch (_) {}
      this.brickController = null
    }
    if (this.element) this.element.innerHTML = ""
  }
}
